import React from 'react';

import type { OverallState } from './types';

interface IStatusRingProps {
  state: OverallState;
  size?: number;
  ariaLabel?: string;
}

const COLOR_BY_STATE: Record<OverallState, string> = {
  full: 'rgb(63, 207, 110)',
  partial: 'rgb(240, 177, 76)',
  error: 'rgb(240, 109, 109)',
  empty: 'rgba(255, 255, 255, 0.22)',
};

const StatusRing = ({ state, size = 22, ariaLabel }: IStatusRingProps) => {
  const r = 8.2;
  const circumference = 2 * Math.PI * r;
  const stroke = COLOR_BY_STATE[state];
  // `partial` shows a half-circle dash; `empty` uses a dotted ring to
  // distinguish "nothing configured" from "fully configured".
  let dasharray: string | undefined;
  if (state === 'partial') {
    dasharray = `${circumference / 2} ${circumference}`;
  } else if (state === 'empty') {
    dasharray = '2.5 4';
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      role={ariaLabel ? 'img' : undefined}
      aria-label={ariaLabel}
      aria-hidden={ariaLabel ? undefined : true}
      style={{ flex: 'none' }}
    >
      <circle
        cx={11}
        cy={11}
        r={r}
        stroke="rgba(255, 255, 255, 0.12)"
        strokeWidth={2.6}
      />
      <circle
        cx={11}
        cy={11}
        r={r}
        stroke={stroke}
        strokeWidth={2.6}
        strokeLinecap="round"
        strokeDasharray={dasharray}
        transform="rotate(-90 11 11)"
      />
      {state === 'error' ? (
        <text
          x={11}
          y={14.6}
          fontSize={10}
          fontWeight={800}
          fill="rgb(240, 109, 109)"
          textAnchor="middle"
        >
          !
        </text>
      ) : null}
    </svg>
  );
};

export default StatusRing;
